<template>
	<div class="aboutContent">
		<div class="left">
			<span style="font-size: 26px;font-weight: 900;color: #98273A;">关于我们</span>
			<span style="padding-top: 5px;color: #98273A;">About Us</span>
			<span style="width: 25px;margin-top: 7px;height: 5px;background-color: #98273A;"></span>
			<span style="padding-top: 50px;font-size: 14px;line-height: 28px;">上海和华利盛律师事务所经上海市司法局核准于2001年在上海市黄浦区成立，先后在重庆、西安、唐山、郑州、海口、太原、合肥设有分所，同时在香港、悉尼等地设有办公室或战略合作伙伴。</span>
			<span style="padding-top: 50px;font-size: 14px;line-height: 28px;">中文名“和华利盛”：包含“和为贵”、“和谐中华”、“专注商业”、“繁荣昌盛”之义。英文名HAWORTH & LEXON：英语与拉丁文的组合，意为“法律之上的价值”。</span>
			<span style="padding-top: 50px;font-size: 14px;line-height: 28px;">和华利盛自成立以来，积极学习国际、国内领先律所的先进运营经验，践行“专业、精致”的海派律师理念，以助力客户成长、成功为目标，以团队合作为基石，以专业化服务为依托，多年来，赢得了包括多家世界500强企业在内的众多客户的认可，在律师业和社会各界享有良好的声誉…</span>
			<button  @click="goAbout()" :style="{cursor:'pointer','margin-top':'50px',width:'120px',left:' 200px',color:'white','font-size':'14px',height:'33px','line-height':'33px','text-align':'center','background-color':'#98273A',border:'0'}">了解更多</button>
		</div>
		<div class="right">
			<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/indexBusinessArea.png" alt="">
		</div>
	</div>
</template>

<script>
	export default{
		methods:{
			goAbout(){
				this.$router.push({
					path: "/aboutUs",
				})
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.aboutContent{
		width: 64%;
		padding: 30px 18%;
		padding-top: 150px;
		display: flex;
		flex-direction: row;
		// justify-content: space-between;
		.left{
			width: 61%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			.cmpName{
				width: 100%;
				height: 50px;
				font-size: 28px;
				font-family: Adobe Heiti Std R;
				color: #2E2E2E;
				line-height: 33px;
				border-bottom: 2px solid #469DFF;
			}
			.cmpInfo{
				width: 600px;
				padding: 10px 0;
				font-size: 21px;
				font-family: Adobe Heiti Std R;
				color: #838383;
				line-height: 33px;
			}
			.button{
				width: 120px;
				height: 36px;
				color: #FFFFFF;
				font-size: 16px;
				line-height: 36px;
				text-align: center;
				border-radius: 20px;
				background-color: #1A86FF;
				cursor: pointer;
				margin-top: 20px;
			}
		}
		.right{
		padding-left: 7%;
    height: 100%;
		}
	}
</style>
